module.exports = __webpack_public_path__ + "static/media/badge.ff34e62d.svg";